import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowLeft } from 'lucide-react';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-[#08090B] text-gray-400 font-mono relative overflow-hidden text-left p-6 md:p-20">
      {/* Grille de fond pour le rappel du Hero */}
      <div className="fixed inset-0 z-0 pointer-events-none opacity-[0.05]" 
           style={{ backgroundImage: 'linear-gradient(#2563eb 1px, transparent 1px), linear-gradient(90deg, #2563eb 1px, transparent 1px)', backgroundSize: '50px 50px' }}>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
         {/* Bouton Retour stylisé */}
         <Link to="/" className="text-blue-500 mb-12 inline-flex items-center gap-2 hover:text-white transition-all font-black uppercase text-xs tracking-[0.3em] border-b border-blue-500/30 pb-2">
           <ArrowLeft size={16} /> RETOUR AU SYSTÈME_PRINCIPAL
         </Link>

         <h1 className="text-white text-3xl md:text-6xl mb-16 italic font-black uppercase tracking-tighter underline decoration-blue-600 decoration-[12px] underline-offset-[12px] text-left">
           MENTIONS LÉGALES
         </h1>

         <div className="space-y-16 border-l border-blue-500/20 pl-6 md:pl-12 text-left text-left">
           {/* 1. ÉDITEUR */}
           <section>
             <h2 className="text-blue-500 font-black uppercase tracking-widest mb-6 flex items-center gap-3 text-lg">
               <ShieldCheck size={24} className="text-blue-400" /> 1. ÉDITEUR DU SITE
             </h2>
             <div className="space-y-2 leading-relaxed text-left">
               <p>Le site <span className="text-white italic font-bold">mtcoaching-business.com</span> est édité par l'entreprise :</p>
               <p className="text-white font-black uppercase tracking-widest text-xl">MT COACHING</p>
               <p>Dirigée par <span className="text-white font-bold italic underline decoration-blue-500/50">Mélissa Tréhoux</span>.</p>
               <p>SIRET : <span className="text-white font-bold tracking-widest">805 317 344 000 28</span></p>
               <p>Siège social : <span className="text-white italic">Eure-et-Loir, France.</span></p>
               <p>Contact : <a href="mailto:melissatrehoux@mtcoachingdesentrepreneurs.com" className="text-blue-400 hover:underline">melissatrehoux@mtcoachingdesentrepreneurs.com</a></p>
             </div>
           </section>

           {/* 2. HÉBERGEMENT */}
           <section>
             <h2 className="text-blue-500 font-black uppercase tracking-widest mb-6 text-lg text-left">2. HÉBERGEMENT</h2>
             <p className="leading-relaxed text-left">Hébergeur : <span className="text-white font-black tracking-wider">OVH SAS</span></p>
             <p className="text-left text-left">2 rue Kellermann, 59100 Roubaix, France.</p>
           </section>

           {/* 3. PROPRIÉTÉ INTELLECTUELLE */}
           <section>
             <h2 className="text-blue-500 font-black uppercase tracking-widest mb-6 text-lg text-left text-left">3. PROPRIÉTÉ INTELLECTUELLE</h2>
             <p className="leading-relaxed text-left text-left">
               Tous les contenus du site <span className="text-white italic font-bold">(textes, images, code source, design)</span>, incluant le logo, sont la propriété exclusive de <span className="text-white font-black underline decoration-blue-600 decoration-4">MT COACHING</span>.
             </p>
             <p className="mt-4 italic text-sm text-gray-600 opacity-70 text-left text-left text-left text-left">
               Toute reproduction, représentation, modification ou publication de ces éléments est strictement interdite sans accord écrit.
             </p>
           </section>
         </div>

         <div className="mt-24 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-[10px] font-bold uppercase tracking-[0.4em] text-gray-700">
           <span>© 2026 MT_COACHING</span>
           <span className="text-blue-900/40 font-mono">Protocol_V.Master.Ready</span>
         </div>
      </div>
    </div>
  );
};

export default MentionsLegales;